import { Box } from '@mui/material'
import ForgotPasswordResponsiveDialog from '~/src/components/auth/forgot-password/ForgotPasswordResponsiveDialog'
import { useTranslations } from '~/src/hooks/useTranslations'
import { LoginFormInterface } from '~/src/types/forms/LoginFormInterface'
import { FormikProps } from 'formik'
import FormikTextField from '~/src/components/mui-wrappers/fields/FormikTextField'
import LoginForgotPasswordLink from '~/src/components/auth/login/LoginForgotPasswordLink'

interface Props {
  form: FormikProps<LoginFormInterface>,
}

const LoginFormFields = ({ form }: Props) => {
  const { t } = useTranslations()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4
      }}
    >
      <FormikTextField
        TextFieldProps={{
          form,
          color: 'content',
          name: 'email',
          inputMode: 'email',
          label: t('auth.whats_your_email')
        }}
      />

      <FormikTextField
        TextFieldProps={{
          form,
          color: 'content',
          name: 'password',
          type: 'password',
          label: t('auth.your_strongest_password'),
          helperText: (
            <ForgotPasswordResponsiveDialog
              activator={
                <LoginForgotPasswordLink>
                  {t('auth.damn_i_forgot_my_password')}
                </LoginForgotPasswordLink>
              }
            />
          )
        }}
      />
    </Box>
  )
}

export default LoginFormFields
